import { ConnectorPlatform, type ExperienceSocialConnector } from '@logto/schemas';

import { getContextualSignInPage } from '@/utils/contextual-sign-in-page';

import { getWechatBindingPresentation } from './presentation';
import { identityOrigin, opaque } from './protocol';

/** Both the native public projection and the server connector list must select it. */
export function selectedWechatConnector(
  connectors: readonly ExperienceSocialConnector[],
  enabled: boolean
): ExperienceSocialConnector | undefined {
  if (!enabled || window.location.origin !== identityOrigin) {
    return;
  }
  const selected = connectors.filter(
    ({ target, platform }) =>
      target === 'wechat' &&
      (platform === ConnectorPlatform.Web || platform === ConnectorPlatform.Universal)
  );
  return selected.length === 1 && opaque(selected[0]?.id) ? selected[0] : undefined;
}

export function currentWechatConnector(connectors: readonly ExperienceSocialConnector[]) {
  const binding = getWechatBindingPresentation();
  const selected = selectedWechatConnector(
    connectors,
    Boolean(binding ?? getContextualSignInPage()?.options.wechat_enabled)
  );
  return binding && selected?.id !== binding.connectorId ? undefined : selected;
}
